export enum OperatorInvoiceStatus {
  Generated = 1,
  Sent = 2,
  Cancelled = 3
}

export enum OperatorInvoiceAdjustmentReason {
  UserCancellation = 1,
  AdminReservationCancellation = 2,
  AdminTicketCancellation = 3,
  OperatorSwitchAway = 4,
  OperatorSwitchTo = 5,
  InvoiceOnlyCancel = 6,
  LostDisputeWithheld = 7
}

export interface IOperatorInvoicePreviewItem {
  operatorId: number;
  operatorName: string;
  journeyReservationId: number;
  tripId: number;
  uniqueJourneyId: string;
  paymentDate: string;
  journeyDate: string;
  lineName: string;
  passengerCount: number;
  totalPrice: number;
  commissionRate: number;
  commissionAmount: number;
  operatorAmount: number;
}

export interface IOperatorInvoiceCancellation {
  operatorId: number;
  operatorName: string;
  adjustmentId: number;
  ticketId: number;
  uniqueJourneyId: string;
  amount: number;
  reason: OperatorInvoiceAdjustmentReason;
  eventDateUtc: string;
}

// Per-operator subtotal line of a (possibly combined) invoice preview.
export interface IOperatorInvoicePreviewOperator {
  operatorId: number;
  operatorName: string;
  reservationRowsCount: number;
  cancellationRowsCount: number;
  totalPrice: number;
  totalGjirafaCommission: number;
  totalOperatorAmount: number;
  totalCancellations: number;
  netBillable: number;
}

export interface IOperatorInvoicePreview {
  operatorId: number;
  operatorName: string;
  periodFrom: string;
  periodTo: string;
  reservationRowsCount: number;
  cancellationRowsCount: number;
  totalPrice: number;
  totalGjirafaCommission: number;
  totalOperatorAmount: number;
  totalCancellations: number;
  netBillable: number;
  // One entry per selected operator (N=1 for the single-operator case).
  operators: IOperatorInvoicePreviewOperator[];
  items: IOperatorInvoicePreviewItem[];
  cancellations: IOperatorInvoiceCancellation[];
}

// Per-operator subtotal line carried by a (possibly combined) invoice. Single-operator
// invoices have exactly one entry; absent on legacy responses that predate multi-operator.
export interface IOperatorInvoiceOperator {
  id: number;
  operatorInvoiceId: number;
  operatorId: number;
  operatorNameSnapshot: string;
  totalPrice: number;
  totalGjirafaCommission: number;
  totalOperatorAmount: number;
  totalCancellations: number;
  netBillable: number;
}

export interface IOperatorInvoice {
  id: number;
  operatorId: number;
  periodFrom: string;
  periodTo: string;
  statusId: OperatorInvoiceStatus;
  totalPrice: number;
  totalGjirafaCommission: number;
  totalOperatorAmount: number;
  totalCancellations: number;
  netBillable: number;
  sentAtUtc: string | null;
  cancelledAtUtc: string | null;
  cancelledByUserId: number | null;
  docSheetUpdatedAtUtc: string | null;
  insertDate: string;
  updateDate: string;
  createdBy: number | null;
  updatedBy: number | null;
  deleted: boolean;
  // Present on combined invoices; undefined on legacy single-operator responses.
  operators?: IOperatorInvoiceOperator[];
}

export interface IOperatorInvoiceRange {
  operatorIds: number[];
  from: string;
  to: string;
}

export interface IMarkSentResponse {
  success: boolean;
  driveFolderUrl: string;
  emailSent: boolean;
}
